var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D1FAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.31421V26.6857",
    stroke: "#059669",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8817 26.6858H22.1181",
    stroke: "#059669",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6505 12.6549V10.6505C10.6505 10.2961 10.7913 9.95619 11.0419 9.70559C11.2925 9.45499 11.6324 9.31421 11.9868 9.31421H24.0131C24.3675 9.31421 24.7074 9.45499 24.9581 9.70559C25.2086 9.95619 25.3494 10.2961 25.3494 10.6505V12.6549",
    stroke: "#059669",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.1cfd37961ee248643c3bdf38a49670ed.svg";
export { ForwardRef as ReactComponent };